import { boxValoresStyles } from './BoxValores.style'

export function boxValoresIO() {
  return {
    styles: boxValoresStyles
  }
}

export type BoxValoresIO = ReturnType<typeof boxValoresIO>
